export enum SeasonEnum {
  SPRING = 'spring',
  SUMMER = 'summer',
  AUTUMN = 'autumn',
  WINTER = 'winter',
  HALLOWEEN = 'halloween',
  VALENTINO = 'valentino',
  CHRISTMAS = 'christmas',
  PROGRAMMERS = 'programmers',
  EASTER = 'easter',
  COMPANY_BIRTHDAY = 'company-birthday',
}
